// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o60T","col":"styles_col__3-2l_"};